import { Config } from '@shared/configs/config';
import * as moment from 'moment';

export const endDateHelper = (termEnd) => {
  return termEnd
    ? (termEnd = moment(termEnd, Config.DATE_SERVER).set('second', 59).format(Config.DATE_SERVER))
    : null;
};
